import React from 'react'

export default function Footer() {
  return (
    <footer>
    <div class="wrapper">
      <small>&copy;2023 <strong>Pranjal Sarode</strong>, All Rights Reserved</small>
      <nav class="footer-nav">
        <a href="#">Back to Top</a>
        <a href="#">Terms of Use</a>
        <a href="#">Privacy</a>
      </nav>
    </div>
  </footer>
  )
}
